import React from "react";
import { Card, Flex, Text } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";

type LookerEmbedProps = {
  url?: string;
};

export const LookerEmbed: React.FC<LookerEmbedProps> = ({ url }) => {
  return (
    <Flex className={styles.lookerEmbedContainer}>
      <Card className={styles.lookerEmbedCard}>
        {url ? (
          <Flex flexDirection="column" className={styles.lookerEmbedIframeContainer}>
            <iframe src={url} title="Embedded Content" className={styles.lookerEmbedIframe} />
          </Flex>
        ) : (
          <Flex
            justifyContent="center"
            alignItems="center"
            className={styles.lookerEmbedIframeContainerEmpty}
          >
            <Text variant="secondary-md">Dashboard will appear here</Text>
          </Flex>
        )}
      </Card>
    </Flex>
  );
};
